import axios from "@/api/axios";

const get_driver_pko = (start, end) => {
  let qs = require("qs");
  return axios.get("/api/checks", {
    params: {
      createDate: {
        after: start,
        before: end,
      },
    },
    paramsSerializer: function (params) {
      return qs.stringify(params, { arrayFormat: "repeat" });
    },
  });
};

const synchronize_check = (id) => {
  return axios.post("/api/check/" + id + "/synchronization", []);
};

export default {
  get_driver_pko,
  synchronize_check,
};
